import React from 'react';
import {Link} from 'react-router-dom';
import securityService from './security.service';
 import ProtectedSubmenu from './protected.submenu.js';
 import ProtectedMenu from './protected.menu.js';

const DynamicMenuGenerate = ({ menuItems }) => {
    return (
      <>
        {menuItems.map((main, i) => {
          const combinedChildren = [];
  
          if (main.menus) {
            main.menus.forEach(menu => combinedChildren.push({ type: 'menu', ...menu }));
          }
  
          if (main.Submenu) {
            main.Submenu.forEach(sub => combinedChildren.push({ type: 'submenu', ...sub }));
          }
  
          const allNames = combinedChildren.flatMap(child =>
            child.type === 'menu'
              ? [child.name]
              : child.menus.map(m => m.name)
          );
  
          return (
            <li className="nav-item" key={`main-${i}`}>
              <ProtectedSubmenu
                displayValue={main.displayValue}
                names={allNames}
                type="mainmenu"
                icon={main.icon}
              />
  
              <ul className="nav nav-treeview">
                {combinedChildren.map((child, index) => {
                  if (child.type === 'menu') {
                    return (
                      <ProtectedMenu
                        key={`menu-${i}-${index}`}
                        to={child.to}
                        name={child.name}
                        displayName={child.displayName}
                      />
                    );
                  }
  
                  if (child.type === 'submenu') {
                    return (
                      <li className="nav-item" key={`submenu-${i}-${index}`}>
                        <ProtectedSubmenu
                          displayValue={child.displayValue}
                          names={child.menus.map(m => m.name)}
                          type={child.type}
                          icon={child.icon}
                        />
  
                        <ul className="nav nav-treeview">
                          {child.menus.map((menu, k) => (
                            <ProtectedMenu
                              key={`submenu-menu-${i}-${index}-${k}`}
                              to={menu.to}
                              name={menu.name}
                              displayName={menu.displayName}
                            />
                          ))}
                        </ul>
                      </li>
                    );
                  }
  
                  return null;
                })}
              </ul>
            </li>
          );
        })}
      </>
    );
  };

  export default   DynamicMenuGenerate;
  {/* 
                {menuItems.map((main, i) => (
    <li className='nav-item' key={`main-${i}`}>
      <ProtectedSubmenu
        displayValue={main.displayValue}
        names={main.Submenu.flatMap(sub => sub.menus.map(m => m.name))}
        type='mainmenu'
        // icon='fa-address-card'
        icon={main.icon }
      />
  
      <ul className='nav nav-treeview'>
        {main.Submenu.map((submenu, j) => (
          <li className='nav-item' key={`submenu-${i}-${j}`}>
            <ProtectedSubmenu
              displayValue={submenu.displayValue}
              names={submenu.menus.map(m => m.name)}
              type={submenu.type}
              icon={submenu.icon}
            />
  
            <ul className='nav nav-treeview'>
              {submenu.menus.map((menu, k) => (
                <ProtectedMenu
                  key={`menu-${i}-${j}-${k}`}
                  to={menu.to}
                  name={menu.name}
                  displayName={menu.displayName}
                />
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </li>
  ))}
       */}
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  {/* {menuItems.map((main, i) => (
    <li className="nav-item" key={`main-${i}`}>
      <ProtectedSubmenu
        displayValue={main.displayValue}
        names={[
          ...(main.menus ? main.menus.map(m => m.name) : []),
          ...(main.Submenu ? main.Submenu.flatMap(sub => sub.menus.map(m => m.name)) : [])
        ]}
        type="mainmenu"
        icon={main.icon}
      />
  
         
      <ul className="nav nav-treeview">
        {main.menus && main.menus.map((menu, mIndex) => (
          <ProtectedMenu
            key={`mainmenu-${i}-${mIndex}`}
            to={menu.to}
            name={menu.name}
            displayName={menu.displayName}
          />
        ))}
  
        
        {main.Submenu && main.Submenu.map((submenu, j) => (
          <li className="nav-item" key={`submenu-${i}-${j}`}>
            <ProtectedSubmenu
              displayValue={submenu.displayValue}
              names={submenu.menus.map(m => m.name)}
              type={submenu.type}
              icon={submenu.icon}
            />
  
            <ul className="nav nav-treeview">
              {submenu.menus.map((menu, k) => (
                <ProtectedMenu
                  key={`menu-${i}-${j}-${k}`}
                  to={menu.to}
                  name={menu.name}
                  displayName={menu.displayName}
                />
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </li>
  ))} */}
  